import React, { useCallback, useEffect, useState } from "react";

import { deleteNotification, getAllNotifications, sendNotification } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Col, MainPage, Row, Message as message } from "components";

export const NotificationList = () => {
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllNotifications = useCallback(() => {
    getAllNotifications({
      signal,
    })
      .then((res) => {
        setNotifications(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  const deleteCurrentNotification = (record) => {
    if (
      // eslint-disable-next-line
      confirm("Are you sure you want to delete this notification? It cannot be undone.")
    ) {
      deleteNotification({
        id: record.id,
        signal,
      })
        .then(() => {
          loadAllNotifications();

          message({
            content: "The gremlins completed your request.",
            icon: "gremlin",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const sendCurrentNotification = (record) => {
    if (
      // eslint-disable-next-line
      confirm(`Are you sure that you want to send this notification to ${record.sendCount} recipients now? You cannot stop once started.`)
    ) {
      sendNotification({
        id: record.id,
        signal,
      })
        .then(() => {
          loadAllNotifications();

          message({
            content: "The gremlins completed your request.",
            icon: "gremlin",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    loadAllNotifications();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${notifications.length} notifications`}
        description="View or manage notifications here."
        extra={
          <Button size="small" type="secondary" href="/notification/add">
            Add
          </Button>
        }
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={notifications}
            config={{
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/notification/update/",
                  tooltip: "Edit this notification",
                },
                {
                  icon: "tabler/send",
                  func: sendCurrentNotification,
                  tooltip: "Send this notification now",
                },
                {
                  icon: "tabler/trash",
                  func: deleteCurrentNotification,
                  tooltip: "Delete this notification",
                },
              ],
              exclude: [],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
